// Source-Code/Client/src/contexts/NotificationContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getApi } from 'views/services/api';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [pendingReservations, setPendingReservations] = useState(0);
  const [complaints, setComplaints] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchNotificationCounts = async () => {
    setLoading(true);
    try {
      const hotelData = JSON.parse(localStorage.getItem('hotelData'));
      if (!hotelData?.hotelId) return;

      // Obtener reservaciones pendientes
      const pendingRes = await getApi(`api/reservation/viewallpendingreservations/${hotelData.hotelId}`);
      if (pendingRes?.data?.reservationData) {
        setPendingReservations(pendingRes.data.reservationData.length);
      }

      // Aquí podrías agregar la lógica para obtener quejas pendientes también
      // const complaintsRes = await getApi(`api/complaint/viewpending/${hotelData.hotelId}`);
      // if (complaintsRes?.data) {
      //   setComplaints(complaintsRes.data.length);
      // }
    } catch (error) {
      console.error('Error fetching notification counts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotificationCounts();

    // Actualizar cada 5 minutos
    const interval = setInterval(fetchNotificationCounts, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        pendingReservations,
        complaints,
        loading,
        refreshNotifications: fetchNotificationCounts
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);
